export default function initHoverCards() {
  const classVisible = 'visible';

  document.querySelectorAll('.three-cards .card').forEach(function(card, i, cards){
    const close = card.querySelector('a.close');
    const opener = card.querySelector('a.card-body-opener');

    opener.addEventListener('click', function(e) {
      e.preventDefault();
      cards.forEach(el=>{
        el.classList.remove(classVisible)
      })
      card.classList.add(classVisible);
    });
    close.addEventListener('click', function(e) {
      e.preventDefault();
      card.classList.remove(classVisible);
    });
  });
}